import { Card, Stack, Typography, Divider, Button, Alert } from "@mui/material";
import Detail from "./Detail";
import { fDateTime } from "../../utils/formatTime";

// Right-hand panel for a draw not yet run: the resolved tournament, the live eligible count,
// and the Run action. The page owns running; this component only surfaces state and calls onRunClick.
export default function DrawRunPanel({
  draw,
  running,
  runError,
  disabledReason,
  onRunClick,
}) {
  const preview = draw.preview ?? {};
  const canRun = Boolean(preview.can_run) && !running;

  return (
    <Card sx={{ p: 3 }}>
      <Typography variant="h6">
        {draw.competitionName || "Active tournament"}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {[draw.seasonLabel, draw.periodLabel].filter(Boolean).join(" · ")}
      </Typography>
      <Typography variant="caption" color="warning.main" sx={{ display: "block", mt: 0.5 }}>
        Confirm this is the EPL season before running the draw.
      </Typography>

      <Divider sx={{ my: 2 }} />

      <Stack direction="row" spacing={4} flexWrap="wrap" useFlexGap sx={{ mb: 3 }}>
        <Detail label="Registration deadline">
          {fDateTime(preview.deadline_at) || "-"}
        </Detail>
        <Detail label="Eligible entrants">{preview.eligible_count ?? 0}</Detail>
      </Stack>

      <Stack direction="row" alignItems="center" spacing={2} flexWrap="wrap" useFlexGap>
        <Button variant="contained" disabled={!canRun} onClick={onRunClick}>
          Run draw
        </Button>
        {disabledReason && (
          <Typography variant="caption" color="text.secondary">
            {disabledReason}
          </Typography>
        )}
      </Stack>

      {runError && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {runError}
        </Alert>
      )}
    </Card>
  );
}
